import React, { useEffect, useState, useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import StudentsPerUniversityChart from "../../components/charts/my_charts/StudentsPerUniversityChart";
import ValueChangeCircle from "../../components/charts/my_charts/ValueChangeCircle";
import StartedStudentsChart from "../../components/charts/my_charts/StartedStudentsChart";
import CompletionRateLineChart from "../../components/charts/my_charts/CompletionRateLineChart";

const Student = () => {
  const { changeBackground, background } = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);

  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const [studentCountChrat, setStudentCountChrat] = useState([]);
  const [studentCountChratCategories, setStudentCountChratCategories] =
    useState([]);

  const [completionStudentAverage, setCompletionStudentAverage] = useState({
    average: 0,
  });

  const [
    completionStudentAverageOutProgram,
    setCompletionStudentAverageOutProgram,
  ] = useState({
    average: 0,
  });

  const [startedStudents, setStartedStudents] = useState([]);
  const [startedCategories, setStartedCategories] = useState([]);

  const [universityCategories, setUniversityCategories] = useState([]);
  const [universityCategoriesCategories, setUniversityCategoriesCategories] =
    useState([]);

  const fetchYears = async () => {
    try {
      const response = await fetch(
        "https://plo.areez.co//api/university/academic_years"
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();
      setYears(data);
      setSelectedYear(data[0].id);
      setTimeout(() => {
        handleSearch(data[0].id);
      }, 0);
    } catch (error) {
      console.error("خطأ:", error);
      setYears([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchStudentCountChrat = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/universities/total_students?academic_year_id=${academicYearId}`
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();

      const studentCounts = data.map((item) => item.total_students);
      const universityNames = data.map((item) => item.university_name);

      setStudentCountChrat(studentCounts);
      setStudentCountChratCategories(universityNames);
    } catch (error) {
      console.error("خطأ:", error);
      setStudentCountChrat([]);
      setStudentCountChratCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCompletionStudentAverage = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/completion/average?academic_year_id=${academicYearId}`
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();

      setCompletionStudentAverage({
        average: data.average_completion_rate,
      });
    } catch (error) {
      console.error("خطأ:", error);
      setCompletionStudentAverage({
        average: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchCompletionStudentAverageOutProgram = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/completion/exit_rate/average?academic_year_id=${academicYearId}`
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();

      setCompletionStudentAverageOutProgram({
        average: data.average_exit_points_completion_rate,
      });
    } catch (error) {
      console.error("خطأ:", error);
      setCompletionStudentAverageOutProgram({
        average: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchStartedStudents = async (academicYearId) => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/universities/started_students?academic_year_id=${academicYearId}`
      );
      const result = await res.json();

      const data = result.data.map((item) => item.total_started_students);
      const categories = result.data.map((item) => item.university_name);

      setStartedStudents(data);
      setStartedCategories(categories);
    } catch (error) {
      console.error("خطأ في تحميل بيانات الطلاب الذين بدأوا:", error);
      setStartedStudents([]);
      setStartedCategories([]);
    }
  };

  const fetchUniversityCompletionRates = async (academicYearId) => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/universities/completion_rate?academic_year_id=${academicYearId}`
      );
      const result = await res.json();

      const rates = result.data.map((item) => item.completion_rate_avg);
      const names = result.data.map((item) => item.university_name);

      setUniversityCategories(rates);
      setUniversityCategoriesCategories(names);
    } catch (error) {
      console.error("خطأ في تحميل بيانات :", error);
      setUniversityCategories([]);
      setUniversityCategoriesCategories([]);
    }
  };

  const convertedSeries = universityCategoriesCategories.map((name, idx) => ({
    name,
    data: [universityCategories[idx]],
  }));

  const handleSearch = (yearId) => {
    // if (!selectedYear) {
    //   alert("يرجى اختيار السنة الدراسية أولاً.");
    //   return;
    // }
    const yearToUse = yearId || selectedYear;
    if (!yearToUse) {
      alert("يرجى اختيار السنة الدراسية أولاً.");
      return;
    }
    setLoading(true);

    fetchStudentCountChrat(yearToUse);
    fetchCompletionStudentAverage(yearToUse);
    fetchCompletionStudentAverageOutProgram(yearToUse);
    fetchStartedStudents(yearToUse);
    fetchUniversityCompletionRates(yearToUse);
  };

  useEffect(() => {
    fetchYears();

    changeBackground({ value: "light", label: "Light" });
  }, []);
  
  return (
    <div className="row">
      <div className="col-12">
        <div className="input-group">
          <select
            className="form-control"
            value={selectedYear || ""}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <option value="">اختر السنة الدراسية</option>
            {years.map((year) => (
              <option key={year.id} value={year.id}>
                {year.name}
              </option>
            ))}
          </select>
          <div className="input-group-append">
            <button
              className="btn btn-primary"
              // onClick={handleSearch}
              onClick={() => handleSearch(selectedYear)}
              disabled={loading}
            >
              <i className="fa fa-search mr-1"></i>{" "}
              {loading ? "جارٍ البحث..." : ""}
            </button>
          </div>
        </div>
      </div>

      {studentCountChrat.length > 0 &&
        studentCountChratCategories.length > 0 && (
          <div className="col-12 col-lg-6 mb-4">
            <StudentsPerUniversityChart
              data={studentCountChrat}
              categories={studentCountChratCategories}
            />
          </div>
        )}

      {completionStudentAverage.average > 0 && (
        <div className="col-12 col-lg-3 mb-4 mt-5">
          <ValueChangeCircle
            percentage={completionStudentAverage.average}
            size={180}
            strokeWidth={14}
            color="#27ae60"
            title="نسبة الطلاب الذين أتموا البرنامج في الحد الأدنى من المدة"
          />
        </div>
      )}

      {completionStudentAverageOutProgram.average > 0 && (
        <div className="col-12 col-lg-3 mb-4 mt-5">
          <ValueChangeCircle
            percentage={completionStudentAverageOutProgram.average}
            size={180}
            strokeWidth={14}
            color="#f39c12"
            title="نسبة الطلاب الذين أتموا نقاط الخروج للبرنامج"
          />
        </div>
      )}

      {startedStudents.length > 0 && (
        <div className="col-12 col-lg-6 mb-4">
          <StartedStudentsChart
            data={startedStudents}
            categories={startedCategories}
            color="#A084CA"
          />
        </div>
      )}

      {universityCategories.length > 0 && (
        <div className="col-12 col-lg-6 mb-4">
          <CompletionRateLineChart
            series={convertedSeries}
            categories={[""]}
            title="مقارنة بين الجامعات في معدل الإتمام"
            colors={["#363062", "#1EA7C5"]}
          />
        </div>
      )}
    </div>
  );
};

export default Student;
